import { render, staticRenderFns } from "./CreateOrgan.vue?vue&type=template&id=72deac5d"
import script from "./CreateOrgan.vue?vue&type=script&lang=js"
export * from "./CreateOrgan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports